import { Image, ImageProps } from "@chakra-ui/react";
import { buildPictureSources, ISrc } from "src/utils/responsive-image-util";
import { Picture } from ".";

export interface IResponsiveImageProps extends Omit<ImageProps, "src" | "srcSet" | "alt"> {
    baseUrl: string;
    alt: string | null;
    onError?: () => void;
    srcSet?: ISrc[];
}

/**
 * @deprecated Use MUI ResponsiveImage instead
 */
export const ResponsiveImage = ({ baseUrl, alt, srcSet, loading = "lazy", onError, ...imageProps }: IResponsiveImageProps) => {
    const { mediaSources, defaultImage } = buildPictureSources(baseUrl, srcSet);

    const onErrorHandle = () => onError && onError();

    return (
        <Picture display="contents">
            {mediaSources.map(mediaSource => (
                <source key={mediaSource.minWidth} media={`(min-width: ${mediaSource.minWidth})`} srcSet={mediaSource.srcSet} />
            ))}
            <Image
                srcSet={defaultImage.srcSet}
                src={defaultImage.src}
                loading={loading}
                alt={alt ?? undefined}
                onError={onErrorHandle}
                {...imageProps}
            />
        </Picture>
    );
};
